import React, { FC } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTriangleExclamation,
  faXmark,
} from "@fortawesome/pro-regular-svg-icons";

const propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  closeDisabled: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  codes: PropTypes.shape({
    buttons: PropTypes.shape({
      submit: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
      back: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    }),
  }).isRequired,
};

type ModalType = PropTypes.InferProps<typeof propTypes>;

export const Modal: FC<ModalType> = ({
  closeDisabled,
  onClose,
  onSubmit,
  title,
  description,
  codes,
}: ModalType) => {
  function handleClose(): void {
    if (closeDisabled) return;
    if (onClose) {
      onClose();
    }
  }

  function handleSubmit(): void {
    if (onSubmit) {
      onSubmit();
    }
  }

  return (
    <div className="modal__overlay" onClick={handleClose}>
      <div
        className="modal__container"
        onClick={(e): void => e.stopPropagation()}
      >
        {!closeDisabled && (
          <span onClick={handleClose} className="close">
            <FontAwesomeIcon icon={faXmark} size="1x" />
          </span>
        )}
        <div className="modal__container__content">
          <FontAwesomeIcon
            icon={faTriangleExclamation}
            color="#F5A61D"
            size="3x"
          />
          <h3>{title}</h3>
          <p>{description}</p>

          <div className="buttons">
            {codes.buttons?.back && (
              <div className="button grey" onClick={handleClose}>
                {codes.buttons?.back}
              </div>
            )}
            {codes.buttons?.submit && (
              <div className="button purple" onClick={handleSubmit}>
                {codes.buttons?.submit}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
